import Vue from "vue";
import Vuex from "vuex";

// modules
import VuexPersist from "vuex-persist";
//import Projects from "./modules/projectStore";
//import Sidebars from "./modules/sidebarsStore";
import ProjectSubViews from "./modules/projectSubViewsStore";
//import loginUser from "./modules/loginUser";
//import geometryStore from "./modules/geometryStore";
//import pheStore from "./modules/pheStore";
//import offertaStore from "./modules/offertaStore";

//Nuovi Store
import _prjModule from "./project";
import _appModule from "./app";
import _authModule from "./auth";
import _conversionModule from "./conversion";
import _dashboardModule from "./dashboard";
import _fluidModule from "./fluid";
import _geometryModule from "./geometry";
import _materialModule from "./material";
import _connectionsModule from "./connections";
import _translationModule from "./translation";
import _colorsModule from "./colors";
import _factorsModule from "./factor";
import _connectionsplatesModule from "./connectionsplates";
import _commonModule from "./common";
import _pressuresModule from "./pressures";
import _pricesModule from "./prices";
import _drawingModule from "./drawing";

const vuexPersist = new VuexPersist({
  key: "unilab-world",
  storage: localStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    //prjModule: Projects,
    //sidebarModule: Sidebars,
    projectSubViewsModule: ProjectSubViews,
    //loginUser,
    //geometryStore,
    //pheStore,
    //offertaStore,
    //=====================
    _appModule,
    _authModule,
    _conversionModule,
    _dashboardModule,
    _fluidModule,
    _geometryModule,
    _materialModule,
    _connectionsModule,
    _prjModule,
    _translationModule,
    _colorsModule,
    _factorsModule,
    _connectionsplatesModule,
    _commonModule,
    _pressuresModule,
    _pricesModule,
    _drawingModule
    //=====================
  },
  plugins: [vuexPersist.plugin]
});
